import type { PavilionCoordinator } from '../../pavilion/PavilionCoordinator';
import type { IHostAnalyticsManager } from '../../../services/analytics/IHostAnalyticsManager';
import { MacroStepRunner, type MacroGuestFrame } from './MacroStepRunner';
export type { MacroGuestFrame };

/** Retains configuration compatibility while rejecting obsolete automatic input paths. */
export class MacroManager {
  private readonly runner = new MacroStepRunner();
  public constructor(private readonly pavilion: PavilionCoordinator, private readonly analytics: IHostAnalyticsManager) {}
  public async executeOnLaunchMacro(): Promise<boolean> {
    const config = this.pavilion.getCampaignConfig();
    if (!config) return false;
    if (!config.onLaunchMacro?.length) return true;
    this.analytics.sendMacroExecutedEvent({ macroType: 'onLaunch', success: false, campaignId: config.campaignId });
    return false;
  }
  public async executeOnJoinMacro(): Promise<void> { this.rejectConfigured('onJoinMacro'); }
  public async executeOnExitMacro(): Promise<void> { this.rejectConfigured('onExitMacro'); }
  public async executeOnInactiveMacro(): Promise<void> { this.rejectConfigured('onInactiveMacro'); }
  public stopInactiveLoop(): void {}
  public reset(): void {}
  public cancel(): void {}
  public async cancelAndWait(): Promise<boolean> { return true; }
  public async runMacroSteps(steps: string[], label = 'Macro', frame?: MacroGuestFrame): Promise<{ success: boolean; reason?: string }> {
    const result = await this.runner.runSteps(steps, label, frame);
    if (!result.success) throw new Error(result.reason);
    return result;
  }
  private rejectConfigured(key: 'onJoinMacro' | 'onExitMacro' | 'onInactiveMacro'): void {
    if (this.pavilion.getCampaignConfig()?.[key]?.length) throw new Error('macro_graph_migration_required');
  }
}
